import { debounce } from './debounceHelper'

const IDLE_TIMEOUT_MS = 60 * 60 * 1000 // 60 minutes
const LAST_ACTIVITY_KEY = 'lastActivityTimestamp'

export const useLogoutTimer = (onTimeout: () => void, timeoutMs: number = IDLE_TIMEOUT_MS) => {
   let timer: ReturnType<typeof setTimeout> | null = null

   const updateLastActivity = () => {
      localStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString())
   }

   const resetTimer = () => {
      updateLastActivity()
      if (timer) clearTimeout(timer)
      timer = setTimeout(onTimeout, timeoutMs)
   }

   const debouncedResetTimer = debounce(resetTimer, 300)

   const handleVisibilityChange = () => {
      if (!document.hidden) {
         const last = parseInt(localStorage.getItem(LAST_ACTIVITY_KEY) || '0', 10)
         if (Date.now() - last > timeoutMs) {
            onTimeout()
         } else {
            resetTimer()
         }
      }
   }

   const events: (keyof WindowEventMap)[] = ['load', 'mousemove', 'keydown', 'scroll', 'click']

   events.forEach((event) => window.addEventListener(event, debouncedResetTimer))
   document.addEventListener('visibilitychange', handleVisibilityChange)

   resetTimer()

   return () => {
      if (timer) clearTimeout(timer)
      events.forEach((event) => window.removeEventListener(event, debouncedResetTimer))
      document.removeEventListener('visibilitychange', handleVisibilityChange)
   }
}
